module.exports = __webpack_public_path__ + "static/media/used18.7a552d8f.JPG";